export const operationAbbreviation = {
  CAPITAL_DECREASE: 'Abbreviation_CapitalDecrease',
  CAPITAL_INCREASE: 'Abbreviation_CapitalIncrease',
  CONSTITUTION: 'Abbreviation_Constitution',
  CONTRIBUTION: 'Abbreviation_Contribution',
  DIVIDENDS_DISTRIBUTION: 'Abbreviation_DividendsDistribution',
  DONATION: 'Abbreviation_Donation',
  ENDORSEMENT: 'Abbreviation_Endorsement',
  HERITAGE: 'Abbreviation_Heritage',
  RECLASSIFICATION: 'Abbreviation_Reclassification',
  RENUMERATION: 'Abbreviation_Renumeration',
  SELL_PARTICIPATION: 'Abbreviation_SellParticipation',
  SPLIT: 'Abbreviation_Split',
  TRANSMISSION: 'Abbreviation_Transmission',
};
